import { render, staticRenderFns } from "./deptInfoMore.vue?vue&type=template&id=39c6b378&scoped=true"
import script from "./deptInfoMore.vue?vue&type=script&lang=js"
export * from "./deptInfoMore.vue?vue&type=script&lang=js"
import style0 from "./deptInfoMore.vue?vue&type=style&index=0&id=39c6b378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c6b378",
  null
  
)

export default component.exports